import React, { useState } from "react";
import { Box, IconButton } from "@mui/material";
import { Fullscreen, FullscreenExit } from "@mui/icons-material";

const FullscreenToggle = () => {
  const [isFullscreen, setIsFullscreen] = useState(
    !!document.fullscreenElement
  );

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement
        .requestFullscreen()
        .then(() => {
          setIsFullscreen(true);
        })
        .catch((err) => {
          console.error("Failed to enter fullscreen:", err);
        });
    } else {
      document
        .exitFullscreen()
        .then(() => {
          setIsFullscreen(false);
        })
        .catch((err) => {
          console.error("Failed to exit fullscreen:", err);
        });
    }
  };

  return (
    <Box display="flex" gap={2} alignItems="center" sx={{cursor: 'pointer'}}  onClick={toggleFullscreen}>
        <span>{isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}</span>
        <IconButton color="inherit">
          {isFullscreen ? <FullscreenExit /> : <Fullscreen />}
        </IconButton>
    </Box>
  );
};

export default FullscreenToggle;
